import React from 'react';

import ChevronIcon from 'assets/chevron-right.svg';

import RowContent, { RowContentProps } from '../RowContent/RowContent';

import styles from './ButtonRow.module.scss';

interface ButtonRowProps extends RowContentProps, React.ButtonHTMLAttributes<HTMLButtonElement> {}

const ButtonRow: React.FC<ButtonRowProps> = ({ icon, text, ...props }) => (
  <button className={styles.buttonRow} {...props}>
    <RowContent icon={icon} text={text}></RowContent>
    <ChevronIcon className={styles.chevron} />
  </button>
);

export default ButtonRow;
